// Utility helpers for computing service duration & man-hours.
// entry_time / exit_time are stored as ISO strings (UTC).
// Man-hours = duration * (1 + support technician count).

export function parseDate(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
}

/**
 * @param {string|null} entryIso
 * @param {string|null} exitIso
 * @param {number} supportCount - number of support technicians (0+)
 * @returns {{
 *   durationMinutes: number|null,
 *   durationLabel: string,
 *   totalTechnicians: number,
 *   manHours: number|null,
 *   manHoursLabel: string,
 * }}
 */
export function computeServiceTimes(entryIso, exitIso, supportCount = 0) {
    const start = parseDate(entryIso);
    const end = parseDate(exitIso);
    const totalTechnicians = 1 + Math.max(0, Number(supportCount) || 0);

    if (!start || !end || end <= start) {
        return {
            durationMinutes: null,
            durationLabel: "—",
            totalTechnicians,
            manHours: null,
            manHoursLabel: "—",
        };
    }
    const ms = end - start;
    const totalMinutes = Math.round(ms / 60000);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    const durationLabel = h > 0 ? `${h}h ${m.toString().padStart(2, "0")}m` : `${m}m`;

    const durationHoursDecimal = ms / 3600000;
    const manHours = durationHoursDecimal * totalTechnicians;
    const manHoursLabel = `${manHours.toFixed(2)} h`;

    return {
        durationMinutes: totalMinutes,
        durationLabel,
        totalTechnicians,
        manHours,
        manHoursLabel,
    };
}

/** Returns "HH:MM" extracted from ISO datetime (local timezone). */
export function formatTime(iso) {
    const d = parseDate(iso);
    if (!d) return "—";
    return d.toLocaleTimeString("es-SV", { hour: "2-digit", minute: "2-digit", hour12: false });
}
